import { render, staticRenderFns } from "./MainCourse.vue?vue&type=template&id=1e6bc58d&"
import script from "./MainCourse.vue?vue&type=script&lang=js&"
export * from "./MainCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports